<div class="m-3 bg-white">
  <mat-accordion [hideToggle]="true"
                 class="m-4 d-block border overflow-hidden"
                 style="border-radius: 0.5rem">
    <mat-expansion-panel class="border-bottom rounded-0 shadow-none m-0"
                         [expanded]="true"
                         #panel1>
      <mat-expansion-panel-header [class.border-bottom]="panel1.expanded">
        <mat-panel-title class="text-uppercase d-flex align-items-center"
                         matTooltip="Add bookings to exclude them from TokeetAI automated responses">
          <i class="fas mr-1"
             [ngClass]="'fa-caret-' + (panel1.expanded ? 'down' : 'right')"></i> Ignore Bookings
        </mat-panel-title>
        <mat-panel-description></mat-panel-description>
      </mat-expansion-panel-header>
      <div class="row mt-3">
        <div class="col-md-6">
          <div class="form-group mb-0">
            <label>Select bookings for Ignore list</label>
            <ng-select bindValue="id"
                       bindLabel="title"
                       [multiple]="true"
                       [clearable]="true"
                       [closeOnSelect]="false"
                       [items]="inquiries$ | async"
                       (search)="onSearchBookings($event)"
                       [formControl]="bookingsCtrl"
                       appearance="outline"
                       appendTo="body"
                       #bookings>
              <ng-template ng-header-tmp>
                <mat-checkbox class="text-black"
                              [checked]="isAllSelected(bookingsCtrl, bookings.items)"
                              (change)="onSelectAll(bookingsCtrl, bookings.items, $event.checked)"
                              #all>
                  {{ all.checked ? 'Unselect all' : 'Select all' }}
                </mat-checkbox>
              </ng-template>
              <ng-template ng-option-tmp
                           let-item="item"
                           let-item$="item$"
                           let-index="index">
                <div class="d-flex align-items-center"
                     style="gap: 1rem">
                  <mat-checkbox id="item-{{index}}"
                                [checked]="item$.selected"
                                style="pointer-events: none;"></mat-checkbox>
                  <div style="line-height: 1.5"
                       class="py-2">
                    <div class="text-truncate">
                      <b>{{ item.title }}</b> at {{ item.rentalId | rentalName | async }}
                    </div>
                    <small class="text-muted">
                      starting {{ item.guestArrive | epoch: 'DD - MMM - YYYY' }} ending
                      {{ item.guestDepart | epoch: 'DD - MMM - YYYY' }}
                    </small>
                  </div>
                </div>
              </ng-template>
            </ng-select>
          </div>
          <button class="btn btn-cst-info text-uppercase text-nowrap"
                  (click)="onSaveBookings()"
                  [disabled]="bookingsCtrl.invalid">
            <i class="far fa-level-down"
               style="transform: rotateY(180deg)"></i> Add To List
          </button>
        </div>
      </div>
      <div class="border  rounded overflow-hidden my-4 bg-white">
        <div class="p-3 border-bottom d-flex">
          <div class="search-group position-relative">
            <i class="fal fa-search position-absolute text-muted"
               style="left: 8px; top: 8px"></i>
            <input class="form-control form-control-sm pl-4"
                   [formControl]="searchBookingsCtrl"
                   type="text"
                   placeholder="Search"
                   matTooltip="Enter name you want to search for"
                   required
                   title="" />
          </div>
          <a href="javascript:;"
             matTooltip="Clear all filters"
             class="ml-auto text-muted"
             (click)="searchBookingsCtrl.reset()"
             style="font-size: 1.2rem">
            <i class="fal fa-minus-circle"></i></a>
        </div>
        <mat-table #table
                   #bookingsSort="matSort"
                   matSort
                   [dataSource]="bookingsDataSource">
          <ng-container matColumnDef="name">
            <mat-header-cell *matHeaderCellDef
                             mat-sort-header> Guest Name</mat-header-cell>
            <mat-cell *matCellDef="let element">{{ element.guestDetails?.name }}</mat-cell>
          </ng-container>

          <ng-container matColumnDef="email">
            <mat-header-cell *matHeaderCellDef
                             mat-sort-header> Guest Email</mat-header-cell>
            <mat-cell *matCellDef="let element">{{ element.guestDetails?.email }}</mat-cell>
          </ng-container>
          <ng-container matColumnDef="guestArrive">
            <mat-header-cell *matHeaderCellDef
                             mat-sort-header> Arrival</mat-header-cell>
            <mat-cell *matCellDef="let element">{{ element.guestArrive | epoch: 'DD - MMM - YYYY' }}</mat-cell>
          </ng-container>
          <ng-container matColumnDef="guestDepart">
            <mat-header-cell *matHeaderCellDef
                             mat-sort-header> Departure</mat-header-cell>
            <mat-cell *matCellDef="let element">{{ element.guestDepart | epoch: 'DD - MMM - YYYY' }}</mat-cell>
          </ng-container>

          <ng-container matColumnDef="actions">
            <mat-header-cell *matHeaderCellDef> Actions</mat-header-cell>
            <mat-cell *matCellDef="let element">
              <a href="javascript:void(0)"
                 class="text-danger"
                 matTooltip="Remove it from ignore list"
                 (click)="onDeleteBooking(element)"><i class="far fa-trash"></i></a>
            </mat-cell>
          </ng-container>

          <mat-header-row *matHeaderRowDef="bookingsColumns"></mat-header-row>
          <mat-row *matRowDef="let row; columns: bookingsColumns"></mat-row>
        </mat-table>
        <app-empty-table type="AIIgnoreBookings"
                         *ngIf="!bookingsDataSource.data?.length"></app-empty-table>

        <mat-paginator #bookingsPaginator
                       [length]="bookingsDataSource?.data?.length"
                       [pageSizeOptions]="[5, 10, 20, 50]"
                       [showFirstLastButtons]="true">
        </mat-paginator>
      </div>
    </mat-expansion-panel>
    <mat-expansion-panel class="border-bottom rounded-0 shadow-none m-0"
                         #panel2>
      <mat-expansion-panel-header [class.border-bottom]="panel2.expanded">
        <mat-panel-title class="text-uppercase d-flex align-items-center"
                         matTooltip="Add guests to exclude them from TokeetAI automated responses">
          <i class="fas mr-1"
             [ngClass]="'fa-caret-' + (panel2.expanded ? 'down' : 'right')"></i> Ignore Guests
        </mat-panel-title>
        <mat-panel-description></mat-panel-description>
      </mat-expansion-panel-header>
      <div class="row mt-3">
        <div class="col-md-6">
          <div class="form-group mb-0">
            <label>Select guests for Ignore List</label>
            <ng-select bindValue="id"
                       bindLabel="name"
                       [multiple]="true"
                       [clearable]="true"
                       [closeOnSelect]="false"
                       [items]="guests$ | async"
                       (search)="onSearchGuests($event)"
                       [formControl]="guestsCtrl"
                       appearance="outline"
                       appendTo="body"
                       #guests>
              <ng-template ng-header-tmp>
                <mat-checkbox class="text-black"
                              [checked]="isAllSelected(guestsCtrl, guests.items)"
                              (change)="onSelectAll(guestsCtrl, guests.items, $event.checked)"
                              #all>
                  {{ all.checked ? 'Unselect all' : 'Select all' }}
                </mat-checkbox>
              </ng-template>
              <ng-template ng-option-tmp
                           let-item="item"
                           let-item$="item$"
                           let-index="index">
                <div class="d-flex align-items-center"
                     style="gap: 1rem">
                  <mat-checkbox id="item-{{index}}"
                                [checked]="item$.selected"
                                style="pointer-events: none;"></mat-checkbox>
                  {{ item.name }} <span class="text-muted ml-auto">{{ item.primaryEmail }}</span>
                </div>
              </ng-template>
            </ng-select>
          </div>
          <button class="btn btn-cst-info text-uppercase text-nowrap"
                  (click)="onSaveGuests()"
                  [disabled]="guestsCtrl.invalid">
            <i class="far fa-level-down"
               style="transform: rotateY(180deg)"></i> Add To List
          </button>
        </div>
      </div>
      <div class="border  rounded overflow-hidden my-4 bg-white">
        <div class="p-3 border-bottom d-flex">
          <div class="search-group position-relative">
            <i class="fal fa-search position-absolute text-muted"
               style="left: 8px; top: 8px"></i>
            <input class="form-control form-control-sm pl-4"
                   [formControl]="searchGuestsCtrl"
                   type="text"
                   placeholder="Search"
                   matTooltip="Enter name you want to search for"
                   required
                   title="" />
          </div>
          <a href="javascript:;"
             matTooltip="Clear all filters"
             class="ml-auto text-muted"
             (click)="searchGuestsCtrl.reset()"
             style="font-size: 1.2rem">
            <i class="fal fa-minus-circle"></i></a>
        </div>
        <mat-table #table
                   #guestsSort="matSort"
                   matSort
                   [dataSource]="guestsDataSource">
          <ng-container matColumnDef="name">
            <mat-header-cell *matHeaderCellDef
                             mat-sort-header> Guest Name</mat-header-cell>
            <mat-cell *matCellDef="let element">{{ element.name }}</mat-cell>
          </ng-container>

          <ng-container matColumnDef="primaryEmail">
            <mat-header-cell *matHeaderCellDef
                             mat-sort-header> Guest Email</mat-header-cell>
            <mat-cell *matCellDef="let element">{{ element.primaryEmail }}</mat-cell>
          </ng-container>

          <ng-container matColumnDef="actions">
            <mat-header-cell *matHeaderCellDef> Actions</mat-header-cell>
            <mat-cell *matCellDef="let element">
              <a href="javascript:void(0)"
                 class="text-danger"
                 matTooltip="Remove it from ignore list"
                 (click)="onDeleteGuest(element)"><i class="far fa-trash"></i></a>
            </mat-cell>
          </ng-container>

          <mat-header-row *matHeaderRowDef="guestsColumns"></mat-header-row>
          <mat-row *matRowDef="let row; columns: guestsColumns"></mat-row>
        </mat-table>
        <app-empty-table type="AIIgnoreGuests"
                         *ngIf="!guestsDataSource.data?.length"></app-empty-table>

        <mat-paginator #guestsPaginator
                       [length]="guestsDataSource?.data?.length"
                       [pageSizeOptions]="[5, 10, 20, 50]"
                       [showFirstLastButtons]="true">
        </mat-paginator>
      </div>
    </mat-expansion-panel>
    <mat-expansion-panel class="border-bottom rounded-0 shadow-none m-0"
                         #panel3>
      <mat-expansion-panel-header [class.border-bottom]="panel3.expanded">
        <mat-panel-title class="text-uppercase d-flex align-items-center"
                         matTooltip="Add regex to exclude the guests from TokeetAI automated responses when emails are matched">
          <i class="fas mr-1"
             [ngClass]="'fa-caret-' + (panel3.expanded ? 'down' : 'right')"></i> Ignore Regex Patterns
        </mat-panel-title>
        <mat-panel-description></mat-panel-description>
      </mat-expansion-panel-header>
      <div class="mt-3">
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label class="form-label">Add Regex Pattern to Ignore List</label>
              <div class="input-group">
                <input type="text"
                       class="form-control"
                       placeholder="Example: gmail.com"
                       [formControl]="ignoreGuestsRegexpCtrl" />
              </div>
            </div>
            <button class="btn btn-cst-info text-uppercase text-nowrap"
                    (click)="onSaveGuestsRegexp()"
                    [disabled]="ignoreGuestsRegexpCtrl.invalid">
              <i class="far fa-level-down"
                 style="transform: rotateY(180deg)"></i> Add To List
            </button>
          </div>
        </div>
        <div class="border  rounded overflow-hidden my-4 bg-white">
          <div class="p-3 border-bottom d-flex">
            <div class="search-group position-relative">
              <i class="fal fa-search position-absolute text-muted"
                 style="left: 8px; top: 8px"></i>
              <input class="form-control form-control-sm pl-4"
                     [formControl]="searchGuestRegexpsCtrl"
                     type="text"
                     placeholder="Search"
                     matTooltip="Enter regexp you want to search for"
                     required
                     title="" />
            </div>
            <a href="javascript:;"
               matTooltip="Clear all filters"
               class="ml-auto text-muted"
               (click)="searchGuestRegexpsCtrl.reset()"
               style="font-size: 1.2rem">
              <i class="fal fa-minus-circle"></i></a>
          </div>
          <mat-table #table
                     #regexpsSort="matSort"
                     matSort
                     [dataSource]="regexpsDataSource">
            <ng-container matColumnDef="content">
              <mat-header-cell *matHeaderCellDef
                               mat-sort-header> Regex</mat-header-cell>
              <mat-cell *matCellDef="let element">{{ element }}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="actions">
              <mat-header-cell *matHeaderCellDef> Actions</mat-header-cell>
              <mat-cell *matCellDef="let element">
                <a href="javascript:void(0)"
                   class="text-danger"
                   matTooltip="Remove it from ignore list"
                   (click)="onDeleteGuestsRegexp(element)"><i class="far fa-trash"></i></a>
              </mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="regexpsColumns"></mat-header-row>
            <mat-row *matRowDef="let row; columns: regexpsColumns"></mat-row>
          </mat-table>
          <app-empty-table type="AIIgnoreGuestsRegexp"
                           *ngIf="!regexpsDataSource.data?.length"></app-empty-table>

          <mat-paginator #regexpsPaginator
                         [length]="regexpsDataSource?.data?.length"
                         [pageSizeOptions]="[5, 10, 20, 50]"
                         [showFirstLastButtons]="true">
          </mat-paginator>
        </div>
      </div>
    </mat-expansion-panel>
    <mat-expansion-panel class="border-bottom rounded-0 shadow-none m-0"
                         #panel4>
      <mat-expansion-panel-header [class.border-bottom]="panel4.expanded">
        <mat-panel-title class="text-uppercase d-flex align-items-center"
                         matTooltip="Add rentals to exclude them from TokeetAI automated responses">
          <i class="fas mr-1"
             [ngClass]="'fa-caret-' + (panel4.expanded ? 'down' : 'right')"></i> Ignore Rentals
        </mat-panel-title>
        <mat-panel-description></mat-panel-description>
      </mat-expansion-panel-header>
      <div class="row mt-3">
        <div class="col-md-6">
          <div class="form-group mb-0">
            <label>Select rentals for Ignore list</label>
            <ng-select bindValue="id"
                       bindLabel="name"
                       [multiple]="true"
                       [clearable]="true"
                       [closeOnSelect]="false"
                       [items]="rentals$ | async"
                       [formControl]="rentalsCtrl"
                       appearance="outline"
                       appendTo="body"
                       #rentals>
              <ng-template ng-header-tmp>
                <mat-checkbox class="text-black"
                              [checked]="isAllSelected(rentalsCtrl, rentals.items)"
                              (change)="onSelectAll(rentalsCtrl, rentals.items, $event.checked)"
                              #all>
                  {{ all.checked ? 'Unselect all' : 'Select all' }}
                </mat-checkbox>
              </ng-template>
              <ng-template ng-option-tmp
                           let-item="item"
                           let-item$="item$"
                           let-index="index">
                <div class="d-flex align-items-center"
                     style="gap: 1rem">
                  <mat-checkbox id="item-{{index}}"
                                [checked]="item$.selected"
                                style="pointer-events: none;"></mat-checkbox>
                  {{ item.name }}
                </div>
              </ng-template>
            </ng-select>
          </div>
          <button class="btn btn-cst-info text-uppercase text-nowrap"
                  (click)="onSaveRentals()"
                  [disabled]="rentalsCtrl.invalid">
            <i class="far fa-level-down"
               style="transform: rotateY(180deg)"></i> Add To List
          </button>
        </div>
      </div>
      <div class="border  rounded overflow-hidden my-4 bg-white">
        <div class="p-3 border-bottom d-flex">
          <div class="search-group position-relative">
            <i class="fal fa-search position-absolute text-muted"
               style="left: 8px; top: 8px"></i>
            <input class="form-control form-control-sm pl-4"
                   [formControl]="searchRentalsCtrl"
                   type="text"
                   placeholder="Search"
                   matTooltip="Enter name you want to search for"
                   required
                   title="" />
          </div>
          <a href="javascript:;"
             matTooltip="Clear all filters"
             class="ml-auto text-muted"
             (click)="searchRentalsCtrl.reset()"
             style="font-size: 1.2rem">
            <i class="fal fa-minus-circle"></i></a>
        </div>
        <mat-table #table
                   #rentalsSort="matSort"
                   matSort
                   [dataSource]="rentalsDataSource">
          <ng-container matColumnDef="name">
            <mat-header-cell *matHeaderCellDef
                             mat-sort-header> Rental Name</mat-header-cell>
            <mat-cell *matCellDef="let element">{{ element.name }}</mat-cell>
          </ng-container>

          <ng-container matColumnDef="email">
            <mat-header-cell *matHeaderCellDef
                             mat-sort-header> Rental Email</mat-header-cell>
            <mat-cell *matCellDef="let element">{{ element.email }}</mat-cell>
          </ng-container>

          <ng-container matColumnDef="actions">
            <mat-header-cell *matHeaderCellDef> Actions</mat-header-cell>
            <mat-cell *matCellDef="let element">
              <a href="javascript:void(0)"
                 class="text-danger"
                 matTooltip="Remove it from ignore list"
                 (click)="onDeleteRental(element)"><i class="far fa-trash"></i></a>
            </mat-cell>
          </ng-container>

          <mat-header-row *matHeaderRowDef="rentalsColumns"></mat-header-row>
          <mat-row *matRowDef="let row; columns: rentalsColumns"></mat-row>
        </mat-table>
        <app-empty-table type="AIIgnoreRentals"
                         *ngIf="!rentalsDataSource.data?.length"></app-empty-table>

        <mat-paginator #rentalsPaginator
                       [length]="rentalsDataSource?.data?.length"
                       [pageSizeOptions]="[5, 10, 20, 50]"
                       [showFirstLastButtons]="true">
        </mat-paginator>
      </div>
    </mat-expansion-panel>

  </mat-accordion>
</div>
